import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'

// redux
import { connect } from 'react-redux'
import roleActions from '../../redux/qbrole/actions'

// sub component
import RoleInfoForm from './role_info_form'

class ModalRoleInfo extends Component {
    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render(){
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Chi tiết phân quyền"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={null}
                width={600}
            >
                <RoleInfoForm 
                    onOk = {() => this._handleOK()}
                    onCancel = {() => this._handleCancel()}
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.qbrole.modalRoleInfoState,
        role: state.qbrole.currentRole
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(roleActions.action.dismissModalCurrentRoleInfo())
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ModalRoleInfo)